/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Add.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import CancelAction from './CancelAction/view.js'
import Companies from './Companies/logic.js'
import Email from './Email/logic.js'
import ExistingUsers from './ExistingUsers/logic.js'
import FirstName from './FirstName/logic.js'
import Info from 'DesignSystem/Info/view.js'
import InviteAction from './InviteAction/view.js'
import LastName from './LastName/logic.js'
import ModalContent from 'DesignSystem/ModalContent/view.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PhoneNumber from './PhoneNumber/logic.js'
import React from 'react'
import Role from './Role/logic.js'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import { css } from "emotion"
Companies.displayName = 'CompaniesLogic'
Email.displayName = 'EmailLogic'
ExistingUsers.displayName = 'ExistingUsersLogic'
FirstName.displayName = 'FirstNameLogic'
LastName.displayName = 'LastNameLogic'
PhoneNumber.displayName = 'PhoneNumberLogic'
Role.displayName = 'RoleLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
marginTop: 24,
  opacity: 'var(--opacity)'})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
marginTop: 30,
  opacity: 'var(--opacity)'})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
marginTop: 20,
marginBottom: 50})

export default function Add({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isExistingUser,
viewPath= "/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Add.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/ModalHeader`}
 text="Add new admin"
>
{childProps => (
<React.Fragment>
<InviteAction
{...childProps}
 data-testid="Add.InviteAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/InviteAction`}
/>
<CancelAction
{...childProps}
 data-testid="Add.CancelAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/CancelAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<ModalContent
 data-testid="Add.ModalContent"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/ModalContent`}
 paddingBottom={100}
>
{childProps => (
<React.Fragment>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Add to the following companies"
/>
<div
 data-testid="Add.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal}`}
>
<Companies
 data-testid="Add.Companies"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/Companies`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Select an existing user"
/>
<div
 data-testid="Add.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal1}`}
>
<ExistingUsers
 data-testid="Add.ExistingUsers"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/ExistingUsers`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Or create a new user"
 marginTop={50}
 opacity={isExistingUser ? 0.5 : 1}
/>
<div
 data-testid="Add.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
 style={{'--opacity': isExistingUser ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal2}`}
>
<FirstName
 data-testid="Add.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="Add.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/LastName`}
/>
</div>
<div
 data-testid="Add.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
 style={{'--opacity': isExistingUser ? 0.5 : 1}}
 className={`views-block ${styles.Horizontal3}`}
>
<PhoneNumber
 data-testid="Add.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/PhoneNumber`}
/>
<Email
 data-testid="Add.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/Email`}
/>
</div>
<Info
{...childProps}
 data-testid="Add.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/Info`}
 marginTop={12}
 marginLeft={8}
 fontSize={12}
 text="All users have one unique profile, so the mobile number is required in case the user becomes a benefits member."
/>
<SubTitle
{...childProps}
 data-testid="Add.SubTitle:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/SubTitle`}
 text="Set editing permissions"
 marginTop={50}
/>
<Info
{...childProps}
 data-testid="Add.Info:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/Info`}
 marginTop={16}
 text="Super-Admins can add, edit, delete, download, sign agreements. Admins have read-only access."
/>
<div
 data-testid="Add.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
 className={`views-block ${styles.Horizontal4}`}
>
<Role
 data-testid="Add.Role"
 data-view-path="/App/MyAccount/Content/Profile/Content/Admins/AddItem/Content/Add"
viewPath={`${viewPath}/Role`}
/>
</div>
</React.Fragment>
)}
</ModalContent>
{children}
</React.Fragment>)
}